import React from "react";
import { DialogButton, DialogConfig, createDialogConfig } from "common/component/SequentialDialog";
import { formatDateStr } from "common/util/date";
import { PendingAuthorizationInfo } from "../../domain";
import { createButton } from "./utils";

const createContent = (pendingAuths: PendingAuthorizationInfo[]): React.ReactNode | null => {
  if (pendingAuths.length === 0) return null;
  
  if (pendingAuths.length === 1) {
    return (
      <div>
        This client has a pending authorization that starts on {formatDateStr(pendingAuths[0].startDate)}, 
        please select to which authorization(s) this addendum applies to
      </div>
    );
  }
  
  return (
    <>
      <div>This client has multiple pending authorizations:</div>
      <ul className="list-disc list-inside">
        {pendingAuths.map(auth => (
          <li key={auth.guid}>
            {auth.bhpnAuthNumber} - Start Date: {formatDateStr(auth.startDate)}
          </li>
        ))}
      </ul>
      <div>Please select to which authorization(s) this addendum applies to</div>
    </>
  );
};

const createButtons = (pendingAuths: PendingAuthorizationInfo[]): DialogButton[] => {
  if (pendingAuths.length === 1) {
    return [
      createButton(
        'Active and Pending Authorizations', 
        { action: 'submit', pendingAuthToUpdate: pendingAuths[0] },
        'green',
        '180px'
      ),
      createButton(
        'Active Authorization Only', 
        { action: 'submit', shouldUpdateActiveAuth: true },
        'green',
        '160px'
      )
    ];
  }
  
  const buttons = [
    createButton(
      'Active Authorization Only', 
      { action: 'submit', shouldUpdateActiveAuth: true },
      'green',
      '160px'
    )
  ];
  
  pendingAuths.forEach(pendingAuth => {
    buttons.push(
      createButton(
        `Active and Auth(${pendingAuth.bhpnAuthNumber})`,
        { action: 'submit', pendingAuthToUpdate: pendingAuth },
        'green',
        '150px'
      )
    );
  });
  
  return buttons;
};

export const createPendingAuthDialogConfig = (
  pendingAuths: PendingAuthorizationInfo[],
  shouldShow: boolean
): DialogConfig => {
  return createDialogConfig(
    'pending-auth-warning',
    'Confirm!',
    createContent(pendingAuths),
    createButtons(pendingAuths),
    shouldShow
  );
};
